import axios from 'axios'
import { Message, Loading } from 'element-ui'

const httpStatus = {
  400: '（错误请求） 服务器不理解请求的语法。',
  401: '（未授权） 请求要求身份验证，未识别到身份。',
  403: '（禁止） 服务器拒绝请求。',
  404: '（未找到） 服务器找不到该请求。',
  405: '（方法禁用） 禁用请求中指定的方法。',
  406: '（不接受） 无法使用请求的内容特性来响应请求。',
  407: '（需要代理授权） 此状态代码与 401（未授权）类似，但指定请求者应当授权使用代理。',
  408: '（请求超时） 服务器等候请求时发生超时。',
  409: '（冲突） 服务器在完成请求时发生冲突。 服务器必须在响应中包含有关冲突的信息。',
  410: '（已删除） 如果请求的资源已永久删除，服务器就会返回此响应。',
  411: '（需要有效长度） 服务器不接受不含有效内容长度标头字段的请求。',
  412: '（未满足前提条件） 服务器未满足请求者在请求中设置的其中一个前提条件。',
  413: '（请求实体过大） 服务器无法处理请求，因为请求实体过大，超出服务器的处理能力。',
  414: '（请求的 URI 过长） 请求的 URI（通常为网址）过长，服务器无法处理。',
  415: '（不支持的媒体类型） 请求的格式不受请求页面的支持。',
  416: '（请求范围不符合要求） 如果页面无法提供请求的范围，则服务器会返回此状态代码。',
  417: '（未满足期望值） 服务器未满足"期望"请求标头字段的要求。',
  500: '（服务器内部错误） 服务器遇到错误，无法完成请求。',
  501: '（尚未实施） 服务器不具备完成请求的功能。 例，服务器无法识别请求方法。',
  502: '（错误网关） 服务器作为网关或代理，从上游服务器收到无效响应。',
  503: '（服务不可用） 服务器目前无法使用（由于超载或停机维护）。 通常，这只是暂时状态。',
  504: '（网关超时） 服务器作为网关或代理，但是没有及时从上游服务器收到请求。',
  505: '（HTTP 版本不受支持） 服务器不支持请求中所用的 HTTP 协议版本。'
}

// 连接超时时间
axios.defaults.timeout = 30000
// 跨域是否需要凭证
axios.defaults.withCredentials = false
// 地址追加
// axios.defaults.baseURL = "/";
// 头部添加
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 请求拦截器
axios.interceptors.request.use(res => {
  return res
})

// 响应拦截器
axios.interceptors.response.use(res => {
  return res.data
})

/**
 * obj: {
 *  method: String 请求类型
 *  url: String 请求路径
 *  headers: Object 请求头
 *  data: Object 参数
 *  loading: Boolean ro String 加载层
 *  tips: Boolean ro String 错误提示
 * }
 */
function request (obj) {
  return new Promise(function (resolve, reject) {
    let loading
    const token = sessionStorage.getItem('token') || null // 用户标识
    const data = {
      method: (obj.method || 'GET').toUpperCase(),
      url: ServerUrl + obj.url,
      responseType: obj.dataType || 'json',
      headers: obj.headers || {}
    }

    token && (data.headers.Authorization = `Bearer ${token}`)

    !obj.data && (obj.data = {})

    const ExamineId = obj.data.examineId || sessionStorage.getItem('ExamineId') || null // 案例ID
    if (ExamineId && (!obj.data.examineId || !obj.data.ExamineId)) {
      obj.data.examineId = Number(ExamineId)
    }

    // 过滤空参
    for (const key in obj.data) {
      if (obj.data[key] === null || obj.data[key] === undefined) {
        delete obj.data[key]
      }
    }

    data[data.method === 'POST' || data.method === 'PUT' ? 'data' : 'params'] = obj.data || {}

    // Loading，参数obj中含有loading才显示。可Boolean,可String
    if (obj.loading) {
      loading = Loading.service({
        text: typeof (obj.loading) === 'string' ? obj.loading : '',
        background: 'rgba(0, 0, 0, 0.6)'
      })
    }

    axios(data).then(res => {
      obj.loading && loading.close()

      if (res.status === 200) {
        resolve(res.data)

        // 提示错误，参数obj中含有tips才提示
        if (obj.tips && !res.data.isSucceed) {
          warningMessage(typeof obj.tips === 'string' ? obj.tips : res.data.message)
        }
      } else {
        reject(res.data)
        errorMessage(typeof obj.tips === 'string' ? obj.tips : httpStatus[res.status])
      }

      obj = null
    }).catch(err => {
      obj.loading && loading.close()

      reject(err)

      if (err.response && !obj.notTip) {
        errorMessage(httpStatus[err.response.status])
      }

      if (err.response.status === 401) {
        window.location.replace('index.html')
      }

      obj = null
    })
  })
}

// 提示问题
function warningMessage (str) {
  Message && Message({
    message: str || '系统发生未知错误',
    duration: 4000,
    type: 'warning',
    showClose: true
  })
}

// 提示错误
function errorMessage (str) {
  Message && Message({
    message: str || '系统发生未知错误',
    duration: 4000,
    type: 'error',
    showClose: true
  })
}

export default request
